import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const autoCloseDelay = 3000;

const Toast = () => <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} autoClose={autoCloseDelay} />;

export default React.memo(Toast);
